module.exports = __webpack_public_path__ + "img/20200515_163044.cc1937f8.jpg";